module.exports = __webpack_public_path__ + "assets/img/guangzhoufoshan.d5fabd1c.png";